import {Component, OnInit, EventEmitter} from "@angular/core";
import {FormBuilder, Validators, FormGroup, FormArray} from "@angular/forms";
import {Languages, Language} from "../../dicts/languages";
import {FirmwareStatuses} from "../../dicts/firmware-statuses";
import {User} from "../../shared/models/user";
import {UserService} from "../../shared/services/api_v1/user.service";
import {FirmwareService} from "../../shared/services/api_v1/firmware.service";
import {MessageService} from "../../shared/services/message.service";
import {MessageType} from "../../shared/models/message";

@Component({
    templateUrl: './upload.component.html',
})
export class UploadComponent implements OnInit{
    form: FormGroup;

    Languages: Language[];
    FirmwareStatuses: string[] ;

    active_tab: string;

    firmwareUploadUrl: string;
    dataUploadUrl: string;

    uploadStart = new EventEmitter<any>();

    subscription;

    firmwares = [];

    constructor(
        private fb:FormBuilder,
        private service: FirmwareService,
        private user:UserService,
        private message: MessageService
    ){
        this.firmwareUploadUrl = service.postFirmwareFileUrl;
        this.dataUploadUrl = service.postFirmwareDataUrl;
        this.Languages = Languages;
        this.FirmwareStatuses = FirmwareStatuses;

        this.active_tab = this.Languages[0].code;
    }

    ngOnInit(): void {
        this.buildForm();

        this.subscription = this.service.getFirmwares()
            .subscribe(
                result => this.firmwares = result,
                result => console.error(result)
            )
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    buildForm(){
        this.form = this.fb.group({
            version: ['', Validators.required],
            status: ['', Validators.required],
            file: ['', Validators.required],
            new_file_url: [''],
            userID: [{value: this.user.active_user.fullname, disabled: true}, Validators.required],
        });

        let changelogs = Languages.map((lang) => {
            return this.fb.group({
                language: [lang.code, Validators.required],
                changelog: [''],
            });
        });

        this.form.setControl('changelogs', this.fb.array(changelogs));
    }

    submit(){
        if(this.form.valid){
            this.uploadStart.emit();
        }
        else{
            this.message.show({
                show_seconds: 5,
                title: 'There are some errors on the form',
                type: MessageType.ERROR
            })
        }
    }

    uploadData(new_file_url){
        this.form.get('new_file_url').setValue(new_file_url);

        this.message.show({
            show_seconds: 5,
            title: 'Firmware file has been uploaded.',
            type: MessageType.INFO
        });

        this.service.postFirmwareData(this.form.value)
            .subscribe(
                res => this.handleSuccess(res),
                error => this.handleError(error),
            );
    }

    handleSuccess(res){
        this.message.show({
            show_seconds: 5,
            title: 'Firmware details have been saved.',
            type: MessageType.INFO
        });
    }

    handleError(error){
        this.message.show({
            show_seconds: 5,
            title: 'Failed to upload firmware',
            type: MessageType.ERROR
        });

        console.error(error);
    }

    get changelogs(): FormArray{
        return this.form.get('changelogs') as FormArray;
    }
}


// WEBPACK FOOTER //
// ./src/app/front/upload/upload.component.ts